import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class RoleAccessService {
  access: any = [];
  object: any = { };
  roleId: string;
  constructor(private restService: RestService) {
    this.roleId = sessionStorage.getItem('roleId');
  }
  getRoleAccess(url: any): Promise<any> {
    return this.restService.model('/screen/GetSideBarByRole/' + this.roleId).toPromise().then((response) => {
      this.access = response;
      this.access.forEach(element => {
        if (element.children === undefined || element.children === 0) {
          if (element.url === url) {
            this.object = element;
          }
        } else {
          element.children.forEach(e => {
            if (e.url === url) {
              this.object = e;
            }
          });
        }
      });
      return this.object;
    });
  }
}
